import React, { Component } from 'react';
import ReactModal from 'react-modal';
import PropTypes from 'prop-types';

class Modal extends Component {

  constructor() {

    super();
    ReactModal.setAppElement('#root');
  }

  disableScroll = () => {
    const _overlay = document.querySelector('.ReactModal__Overlay');
    let _clientY = null; // remember Y position on touch start


    _overlay.addEventListener('touchstart', (event) => {
      if (event.targetTouches.length === 1) {
        // detect single touch
        _clientY = event.targetTouches[0].clientY;
      }
    }, true);

    _overlay.addEventListener('touchmove', (event) => {
      if (event.targetTouches.length === 1) {
        // detect single touch
        this.disableRubberBand(event, _clientY, _overlay);
      }
    }, true);
  }

  isOverlayTotallyScrolled = (overlay) => {
    // https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
    return overlay.scrollHeight - overlay.scrollTop <= overlay.clientHeight;
  }

  disableRubberBand = (event, clY, overlay) => {
    const clientY = event.targetTouches[0].clientY - clY;

    if (event.target.closest('.custom-scrollbar')) {
      event.target.closest('.custom-scrollbar').scrollTo(clientY);
      event.preventDefault();
    } else {
      if (overlay.scrollTop === 0 && clientY > 0) {
        event.preventDefault();
      }
    }

    if (this.isOverlayTotallyScrolled(overlay) && clientY < 0) {
      event.preventDefault();
    }
  }

  afterOpen = () => {
    if (!this.props.enableScroll) {
      this.disableScroll();
    }
    this.props.onAfterOpen && this.props.onAfterOpen();
  }

  afterClose = () => {
    this.props.onRequestClose && this.props.onRequestClose();
  }

  render() {
    return (
      <ReactModal
        {...this.props}
        onAfterOpen={this.afterOpen}
        onRequestClose={this.afterClose}
        shouldReturnFocusAfterClose
        className={this.props.className}
        overlayClassName={this.props.overlayClassName}
        htmlOpenClassName={this.props.htmlOpenClassName}
        ariaHideApp={this.props.ariaHideApp}
      >
        <div className={this.props.contentWrapperClass}>
          {!this.props.hideButton && <button className={this.props.closePopupClass} onClick={this.afterClose} />}
          {this.props.children}
        </div>
      </ReactModal>
    );
  }
}

export default Modal;

Modal.propTypes = {
  className: PropTypes.string,
  overlayClassName: PropTypes.string,
  htmlOpenClassName: PropTypes.string,
  contentWrapperClass: PropTypes.string,
  closePopupClass: PropTypes.string,
  ariaHideApp: PropTypes.bool,
  hideButton: PropTypes.bool,
};

Modal.defaultProps = {
  className: 'popup-content',
  overlayClassName: 'popup-overlay',
  htmlOpenClassName: 'ReactModal__Html--open',
  contentWrapperClass: 'popup-content-details',
  closePopupClass: 'close-popup icon-close-simple',
  ariaHideApp: false,
  hideButton: false
};




// WEBPACK FOOTER //
// ./js/components/global/Modal.js